import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Clock, Loader2 } from 'lucide-react';
import MotoShell from '../components/MotoShell';
import { api } from '../lib/api';

export default function MotoMagazinePage() {
  const [enquetes, setEnquetes] = useState(null);

  useEffect(() => {
    document.title = 'Le Magazine — 31 enquêtes 2 roues | Code 2 Roues';
    api.motoCatalog().then((d) => setEnquetes(d.enquetes)).catch(() => setEnquetes([]));
  }, []);

  return (
    <MotoShell>
      <section className="max-w-7xl mx-auto px-4 lg:px-6 pt-10 sm:pt-14" data-testid="moto-magazine-page">
        <div className="text-[10.5px] uppercase tracking-[0.22em] text-sky-400 font-bold font-mono-spec mb-2">Le magazine · Enquêtes ECSR</div>
        <h1 className="font-serif-editorial text-[30px] sm:text-5xl leading-[1.05] max-w-3xl">Des enquêtes, pas des fiches de révision.</h1>
        <p className="text-white/60 text-[13.5px] sm:text-[15px] mt-3 max-w-2xl leading-relaxed">
          {enquetes ? enquetes.length : 31} longs formats écrits par des moniteurs ECSR : témoignages, chiffres ONISR, pièges réels. Le 2 roues raconté comme il se vit.
        </p>
        {!enquetes ? (
          <div className="py-24 flex justify-center"><Loader2 className="animate-spin text-sky-400" size={28} /></div>
        ) : (
          <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {enquetes.map((e) => (
              <Link key={e.slug} to={`/moto/enquete/${e.slug}`} data-testid={`moto-enquete-card-${e.slug}`}
                className="group rounded-2xl overflow-hidden border border-white/10 bg-[#0b0f1a] hover:border-sky-500/40 transition-colors flex flex-col">
                <div className="h-40 overflow-hidden shrink-0">
                  <img src={e.heroImage} alt={e.title} loading="lazy" className="w-full h-full object-cover opacity-75 group-hover:opacity-95 group-hover:scale-105 transition duration-500" />
                </div>
                <div className="p-4 flex-1 flex flex-col">
                  <div className="text-sky-300 text-[10px] font-mono-spec uppercase tracking-widest font-bold">{e.kicker || e.category}</div>
                  <div className="font-serif-editorial text-white text-[18px] leading-snug mt-1.5 group-hover:text-sky-200 transition-colors">{e.title}</div>
                  <p className="text-white/50 text-[12px] leading-snug mt-2 line-clamp-3 flex-1">{e.subtitle}</p>
                  <div className="mt-3 text-white/35 text-[11px] font-mono-spec inline-flex items-center gap-1.5"><Clock size={11} /> {e.readTimeMin} min de lecture</div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </MotoShell>
  );
}
